import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';

import { CustomAutoComplete } from 'common/components/customFields/CustomAutoComplete';
import { CustomDatePicker } from 'common/components/customFields/CustomDatePicker';
import { CustomInput } from 'common/components/customFields/CustomInput';
import CustomizedSwitches from 'common/components/customFields/CustomizedSwitches';
import { CustomRadioGroup } from 'common/components/customFields/CustomRadioGroup';
import InputNumber from 'common/components/customFields/InputNumber';
import SelectDown from 'common/components/customFields/SelectDown';
import Seo from 'common/components/seo/Seo';
import { CheckAuthorization } from 'common/components/PrivateRoute';
import useDebounce from 'common/hooks/useDebounce';
import { selectCompWording } from 'common/wording/selectors.wording';
import { AccountTypes, ProductTypes } from 'features/auth/constants';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getConfigAction, updateFieldAction } from '../../actions.situation';
import {
  salarieSituationConfig,
  situationSalarieFields,
  familialSituation,
} from '../../constants.situation';
import { getSituationInfoByArraySelector } from '../../selector.situation';
import { getSessionStorage } from 'common/utils/sessionStorage.util';
import Tooltip from 'common/components/customFields/CustomTooltip';
import { getSimulationInfoByArraySelector } from 'features/home/selector.simulation';
import {
  CODE_CONVENTION,
  LANG_STATE,
} from 'features/home/constants.simulation';
import useProfNotConvStyles from './styles/useProfNotConvStyles';

const ProfessionnelClient = () => {
  const classes = useProfNotConvStyles();
  const dispatch = useDispatch();
  const langSelected: any =
    useSelector(getSimulationInfoByArraySelector(['lang'])) || LANG_STATE.FR;
  const wordingSalarie = useSelector(selectCompWording('detailedForm'));
  const cinOrRibList = [
    {
      label: wordingSalarie?.cin,
      value: 'cin',
    },
    {
      label: wordingSalarie?.rib,
      value: 'rib',
    },
  ];

  const additionalIncomeNatureList = [
    {
      label: wordingSalarie?.foncierLoyer,
      value: '1',
    },
    {
      label: wordingSalarie?.placementsFinanciers,
      value: '2',
    },
    {
      label: wordingSalarie?.rente,
      value: '3',
    },
    {
      label: wordingSalarie?.pension,
      value: '4',
    },
    {
      label: wordingSalarie?.autresNature,
      value: '5',
    },
  ];

  const listDiffere = [
    { label: wordingSalarie?.mois1, value: 1 },
    { label: wordingSalarie?.mois2, value: 2 },
    { label: wordingSalarie?.mois3, value: 3 },
  ];

  const errorsWording = useSelector(selectCompWording('errors'));
  const situationSalarie: any = useSelector(
    getSituationInfoByArraySelector(['situationSalarie', 'fields']),
  );
  let situatSalarie: any = null;
  situatSalarie = getSessionStorage('situationSalarie');
  const errors: any = useSelector(
    getSituationInfoByArraySelector(['situationSalarie', 'errors']),
  );
  const [queryCityName] = React.useState<string | undefined>(undefined);
  const debouncedQueryCityName = useDebounce(500, queryCityName);
  const config: any = useSelector(
    getSituationInfoByArraySelector(['situationSalarie', 'config']),
  );
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (situationSalarie.familialSituation !== familialSituation.marie) {
      dispatch(updateFieldAction('situationSalarie', 'activeSpouse', false));
    }
    dispatch(
      updateFieldAction(
        'situationSalarie',
        event.target.name,
        event.target.value,
      ),
    );
  };

  const handleChangeCity = (
    event: React.ChangeEvent<{}>,
    city: { value: string; label: string },
  ) => {
    dispatch(updateFieldAction('situationSalarie', 'city', city));
  };

  useEffect(() => {
    if (
      debouncedQueryCityName &&
      (debouncedQueryCityName as string).length > 2
    ) {
      dispatch(getConfigAction(salarieSituationConfig.cities, queryCityName));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, debouncedQueryCityName]);

  useEffect(() => {
    dispatch(getConfigAction(salarieSituationConfig.familialSituation));
    dispatch(getConfigAction(salarieSituationConfig.activityArea));
    dispatch(getConfigAction(salarieSituationConfig.nationalities));
    dispatch(getConfigAction(salarieSituationConfig.cities));
    dispatch(
      updateFieldAction('situationSalarie', 'type', AccountTypes.professionnel),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isConv = getSessionStorage('codeConvention') !== CODE_CONVENTION.X8;
  console.log(isConv, getSessionStorage('codeConvention'));
  return (
    <CheckAuthorization
      roles={{
        typeClients: [AccountTypes.professionnel],
        products: [ProductTypes.cp],
      }}
    >
      <div className={classes.groupFormBody}>
        <Seo titleKey='title_10' keywordsKey='keywords_10' />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <SelectDown
              formLabel={wordingSalarie?.familialSituation}
              list={config[salarieSituationConfig.familialSituation]}
              label={wordingSalarie?.familialSituationPlaceHolder}
              name={situationSalarieFields.familialSituation}
              value={situationSalarie.familialSituation}
              onChange={handleChange}
              error={
                errors[situationSalarieFields.familialSituation]
                  ? errorsWording[
                      errors[situationSalarieFields.familialSituation]
                    ]
                  : null
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            {situationSalarie.familialSituation === familialSituation.marie && (
              <CustomizedSwitches
                formLabel={wordingSalarie?.activeSpouse}
                tooltip={wordingSalarie?.infoActiveSpouse}
                labelPrefix={wordingSalarie?.no}
                labelSufix={wordingSalarie?.yes}
                checked={situationSalarie.activeSpouse}
                onChange={handleChange}
                name={situationSalarieFields.activeSpouse}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomAutoComplete
              onChangeValue={handleChangeCity}
              options={config[salarieSituationConfig.cities]}
              name={situationSalarieFields.city}
              value={situationSalarie.city}
              formLabel={wordingSalarie?.city}
              placeholder={wordingSalarie?.cityOfResidencePlaceHolder}
              loadingText={'chargement'}
              error={
                errors[situationSalarieFields.city]
                  ? errorsWording[errors[situationSalarieFields.city]]
                  : null
              }
              hasDefaultBorder={false}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SelectDown
              formLabel={wordingSalarie?.nationality}
              list={config[salarieSituationConfig.nationalities]}
              label={wordingSalarie?.nationalityPlaceHolder}
              name={situationSalarieFields.nationality}
              value={situationSalarie.nationality}
              onChange={handleChange}
              error={
                errors[situationSalarieFields.nationality]
                  ? errorsWording[errors[situationSalarieFields.nationality]]
                  : null
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputNumber
              formLabel={wordingSalarie?.numberPersonWhitoutChilds}
              onChange={handleChange}
              name={situationSalarieFields.numberPersonWhitoutChilds}
              value={situationSalarie.numberPersonWhitoutChilds}
              placeholder={wordingSalarie?.numberPersonWhitoutChildsPlaceHolder}
              suffix={''}
              endElement={''}
              hasDefaultBorder={true}
              error={
                errors[situationSalarieFields.numberPersonWhitoutChilds]
                  ? errorsWording[
                      errors[situationSalarieFields.numberPersonWhitoutChilds]
                    ]
                  : null
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputNumber
              formLabel={wordingSalarie?.numberChilds}
              onChange={handleChange}
              name={situationSalarieFields.numberChilds}
              value={situationSalarie.numberChilds}
              placeholder={wordingSalarie?.numberChildsPlaceHolder}
              suffix={''}
              endElement={''}
              hasDefaultBorder={true}
              error={
                errors[situationSalarieFields.numberChilds]
                  ? errorsWording[errors[situationSalarieFields.numberChilds]]
                  : null
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SelectDown
              formLabel={wordingSalarie?.activityArea}
              list={config[salarieSituationConfig.activityArea]}
              label={wordingSalarie?.activityAreaPlaceHolder}
              name={situationSalarieFields.activityArea}
              value={situationSalarie.activityArea}
              onChange={handleChange}
              error={
                errors[situationSalarieFields.activityArea]
                  ? errorsWording[errors[situationSalarieFields.activityArea]]
                  : null
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomDatePicker
              isMinMax={true}
              formLabel={wordingSalarie?.activityStartDate}
              name={situationSalarieFields.dateCurrentEmployer}
              value={situationSalarie.dateCurrentEmployer}
              tooltip={wordingSalarie?.infoActivityStartDate}
              onChange={handleChange}
              format='MM/yyyy'
              views={['year', 'month']}
              placeholder={wordingSalarie?.activityStartDatePlaceHolder}
              hasDefaultBorder={true}
              error={
                errors[situationSalarieFields.dateCurrentEmployer]
                  ? errorsWording[
                      errors[situationSalarieFields.dateCurrentEmployer]
                    ]
                  : null
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputNumber
              formLabel={wordingSalarie?.monthlyIncome}
              tooltip={wordingSalarie?.infoMonthlyIncome}
              onChange={handleChange}
              name={situationSalarieFields.monthlyIncome}
              value={situationSalarie.monthlyIncome}
              placeholder={wordingSalarie?.placeHolderMonthlyIncome}
              suffix={''}
              endElement={wordingSalarie?.dhs}
              decimalSeparator=','
              hasDefaultBorder={true}
              error={
                errors[situationSalarieFields.monthlyIncome]
                  ? errorsWording[errors[situationSalarieFields.monthlyIncome]]
                  : null
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomizedSwitches
              formLabel={wordingSalarie?.additionalIncome}
              tooltip={wordingSalarie?.infoAdditionalIncome}
              labelPrefix={wordingSalarie?.no}
              labelSufix={wordingSalarie?.yes}
              checked={situationSalarie.additionalIncome}
              onChange={handleChange}
              name={situationSalarieFields.additionalIncome}
            />
          </Grid>
          {situationSalarie.additionalIncome === true && (
            <>
              <Grid item xs={12} sm={6}>
                <SelectDown
                  formLabel={wordingSalarie?.additionalIncomeNature}
                  list={additionalIncomeNatureList}
                  label={wordingSalarie?.additionalIncomeNaturePlaceHolder}
                  name={situationSalarieFields.additionalIncomeNature}
                  value={situationSalarie.additionalIncomeNature}
                  onChange={handleChange}
                  error={
                    errors[situationSalarieFields.additionalIncomeNature]
                      ? errorsWording[
                          errors[situationSalarieFields.additionalIncomeNature]
                        ]
                      : null
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputNumber
                  formLabel={wordingSalarie?.amountadditionalIncome}
                  onChange={handleChange}
                  name={situationSalarieFields.amountadditionalIncome}
                  value={situationSalarie.amountadditionalIncome}
                  placeholder={
                    wordingSalarie?.placeHolderAmountadditionalIncome
                  }
                  suffix={''}
                  endElement={wordingSalarie?.dhs}
                  decimalSeparator=','
                  hasDefaultBorder={true}
                  error={
                    errors[situationSalarieFields.amountadditionalIncome]
                      ? errorsWording[
                          errors[situationSalarieFields.amountadditionalIncome]
                        ]
                      : null
                  }
                />
              </Grid>
            </>
          )}
          <Grid item xs={12} sm={6}>
            <InputNumber
              formLabel={wordingSalarie?.bankDebit}
              tooltip={wordingSalarie?.infoMonthlyTotalCredits}
              onChange={handleChange}
              name={situationSalarieFields.bankDebit}
              value={situationSalarie.bankDebit}
              placeholder={wordingSalarie?.placeHolderMonthlyTotalCredits}
              suffix={''}
              endElement={wordingSalarie?.dhs}
              decimalSeparator=','
              hasDefaultBorder={true}
              error={
                errors[situationSalarieFields.bankDebit]
                  ? errorsWording[errors[situationSalarieFields.bankDebit]]
                  : null
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputNumber
              formLabel={wordingSalarie?.monthlyCreditImmovable}
              tooltip={wordingSalarie?.infoMonthlyCreditImmovable}
              onChange={handleChange}
              name={situationSalarieFields.monthlyCreditImmovable}
              value={situationSalarie.monthlyCreditImmovable}
              placeholder={wordingSalarie?.placeHolderMonthlyCreditImmovable}
              suffix={''}
              endElement={wordingSalarie?.dhs}
              decimalSeparator=','
              hasDefaultBorder={true}
              error={
                errors[situationSalarieFields.monthlyCreditImmovable]
                  ? errorsWording[
                      errors[situationSalarieFields.monthlyCreditImmovable]
                    ]
                  : null
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomDatePicker
              isDefault={true}
              formLabel={wordingSalarie?.dateLastTransfer}
              name={situationSalarieFields.dateLastVirement}
              value={situationSalarie.dateLastVirement}
              onChange={handleChange}
              format='dd/MM/yyyy'
              placeholder={wordingSalarie?.dateLastTransferPlaceholder}
              hasDefaultBorder={true}
              error={
                errors[situationSalarieFields.dateLastVirement]
                  ? errorsWording[
                      errors[situationSalarieFields.dateLastVirement]
                    ]
                  : null
              }
            />
          </Grid>
          {isConv ? (
            <Grid item xs={12} sm={6}>
              <CustomizedSwitches
                isHighlighted
                formLabel={wordingSalarie?.isDiffere}
                tooltip={wordingSalarie?.infoDiffere}
                labelPrefix={wordingSalarie?.no}
                labelSufix={wordingSalarie?.yes}
                checked={situationSalarie.isDiffere}
                onChange={handleChange}
                name={situationSalarieFields.isDiffere}
              />
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} className={classes.displayDiv} />
          )}
          {situationSalarie.isDiffere && (
            <>
              <Grid item xs={12} sm={6} className={classes.displayDiv} />
              <Grid item xs={12} sm={6}>
                <SelectDown
                  formLabel={wordingSalarie?.differe}
                  list={listDiffere}
                  label={wordingSalarie?.differePlaceHolder}
                  name={situationSalarieFields.differe}
                  value={situationSalarie.differe}
                  onChange={handleChange}
                  error={
                    errors[situationSalarieFields.differe]
                      ? errorsWording[errors[situationSalarieFields.differe]]
                      : null
                  }
                />
              </Grid>
            </>
          )}

          {(situatSalarie && situatSalarie.listRibBmce) ||
          situationSalarie.listRibBmce ? (
            <>
              <Grid item xs={12} sm={6}>
                <FormLabel className={classes.labelRenseing} component='legend'>
                  {wordingSalarie?.cin}
                </FormLabel>
                <CustomInput
                  value={situationSalarie.cin}
                  name={situationSalarieFields.cin}
                  onChange={handleChange}
                  placeholder={wordingSalarie?.placeHolderCin}
                  hasDefaultBorder={true}
                  disabled={situationSalarie.cinBmce}
                  error={
                    errors[situationSalarieFields.cin]
                      ? errorsWording[errors[situationSalarieFields.cin]]
                      : null
                  }
                />
              </Grid>
              <Grid
                item
                sm={situatSalarie || situationSalarie.listRibBmce ? 6 : 12}
              >
                <div className={classes.globalTooltip}>
                  <FormLabel
                    className={classes.labelRenseingTooltip}
                    component='legend'
                  >
                    {errors.global ? (
                      <div className={classes.error}>
                        {wordingSalarie?.cinOrRibInfo}
                      </div>
                    ) : (
                      wordingSalarie?.rib
                    )}
                    <Tooltip content={wordingSalarie?.infoRib} />
                  </FormLabel>
                </div>
                {situatSalarie || situationSalarie.listRibBmce.length === 1 ? (
                  <CustomInput
                    value={
                      situationSalarie.rib
                        ? situationSalarie.rib
                        : situatSalarie.rib
                    }
                    name={situationSalarieFields.rib}
                    onChange={handleChange}
                    hasDefaultBorder={true}
                    disabled={true}
                  />
                ) : (
                  <SelectDown
                    list={
                      situationSalarie.listRibBmce
                        ? situationSalarie.listRibBmce
                        : situatSalarie.listRibBmce
                    }
                    label={
                      situationSalarie.listRibBmce
                        ? situationSalarie.listRibBmce[0].value
                        : situatSalarie.listRibBmce[0].value
                    }
                    name={situationSalarieFields.rib}
                    value={situationSalarie.rib}
                    onChange={handleChange}
                    error={
                      errors[situationSalarieFields.rib]
                        ? errorsWording[errors[situationSalarieFields.rib]]
                        : null
                    }
                  />
                )}
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12} sm={6}>
                <FormLabel className={classes.labelRenseing} component='legend'>
                  {wordingSalarie?.cinOrRib}
                </FormLabel>
                <Grid item xs={12} sm={8} className={classes.gridItem}>
                  <CustomRadioGroup
                    className={classes.radioGroup}
                    name={situationSalarieFields.cinOrRib}
                    onChange={handleChange}
                    value={situationSalarie.cinOrRib}
                    listOfElements={cinOrRibList}
                    error=''
                  />
                </Grid>
              </Grid>
              {situationSalarie.cinOrRib === 'cin' && (
                <Grid item xs={12} sm={6}>
                  <FormLabel
                    className={classes.labelRenseing}
                    component='legend'
                  >
                    {wordingSalarie?.cin}
                  </FormLabel>
                  <CustomInput
                    value={situationSalarie.cin}
                    name={situationSalarieFields.cin}
                    onChange={handleChange}
                    placeholder={wordingSalarie?.placeHolderCin}
                    hasDefaultBorder={true}
                    disabled={situationSalarie.cinBmce}
                    error={
                      errors[situationSalarieFields.cin]
                        ? errorsWording[errors[situationSalarieFields.cin]]
                        : null
                    }
                  />
                </Grid>
              )}
              {/** RIB BEGIN */}
              {situationSalarie.cinOrRib === 'rib' && (
                <Grid item sm={situationSalarie.listRibBmce ? 6 : 12}>
                  <div className={classes.globalTooltip}>
                    <FormLabel
                      className={classes.labelRenseingTooltip}
                      component='legend'
                    >
                      {errors.global ? (
                        <div className={classes.error}>
                          {wordingSalarie?.cinOrRibInfo}
                        </div>
                      ) : (
                        wordingSalarie?.rib
                      )}
                      <Tooltip content={wordingSalarie?.infoRib} />
                    </FormLabel>
                  </div>
                  <div
                    className={
                      langSelected === LANG_STATE.FR
                        ? classes.elementsRib
                        : classes.elementsRibAr
                    }
                  >
                    <InputNumber
                      onChange={handleChange}
                      name={situationSalarieFields.ribFirstContent}
                      value={situationSalarie.ribFirstContent}
                      placeholder='011'
                      disabled={true}
                      format='###'
                      suffix={''}
                      endElement=''
                      hasDefaultBorder={true}
                      className={`${
                        langSelected === LANG_STATE.FR
                          ? classes.textFieldRib
                          : classes.textFieldRibAr
                      } ${classes.whithoutMsgError}`}
                      error={
                        errors[situationSalarieFields.ribFirstContent]
                          ? errorsWording[
                              errors[situationSalarieFields.ribFirstContent]
                            ]
                          : null
                      }
                    />
                    <InputNumber
                      onChange={handleChange}
                      name={situationSalarieFields.ribSecondContent}
                      value={situationSalarie.ribSecondContent}
                      placeholder='- - -'
                      format='###'
                      suffix={''}
                      endElement=''
                      hasDefaultBorder={true}
                      className={`${
                        langSelected === LANG_STATE.FR
                          ? classes.textFieldRib
                          : classes.textFieldRibAr
                      } ${classes.whithoutMsgError} `}
                      error={
                        errors[situationSalarieFields.ribSecondContent] ||
                        errors[situationSalarieFields.rib]
                      }
                    />
                    <InputNumber
                      onChange={handleChange}
                      name={situationSalarieFields.ribThirdContent}
                      value={situationSalarie.ribThirdContent}
                      placeholder='- -  - - -  - -  - - - - -'
                      format='## ### ## #####'
                      suffix={''}
                      endElement=''
                      hasDefaultBorder={true}
                      startElement={'0000'}
                      className={`${
                        langSelected === LANG_STATE.FR
                          ? classes.textFieldRib
                          : classes.textFieldRibAr
                      } ${classes.thirdTextFieldRib} ${
                        classes.whithoutMsgError
                      } `}
                      error={
                        errors[situationSalarieFields.ribThirdContent] ||
                        errors[situationSalarieFields.rib]
                      }
                    />
                    <InputNumber
                      onChange={handleChange}
                      name={situationSalarieFields.ribLastContent}
                      value={situationSalarie.ribLastContent}
                      placeholder='- -'
                      format='##'
                      suffix={''}
                      hasDefaultBorder={true}
                      endElement=''
                      className={`${
                        langSelected === LANG_STATE.FR
                          ? classes.textFieldRib
                          : classes.textFieldRibAr
                      } ${classes.lastTextFieldRib} ${
                        classes.whithoutMsgError
                      } `}
                      error={
                        errors[situationSalarieFields.ribLastContent] ||
                        errors[situationSalarieFields.rib]
                      }
                    />
                  </div>
                  <p className={classes.error}>
                    {errors[situationSalarieFields.ribFirstContent] ||
                    errors[situationSalarieFields.ribSecondContent] ||
                    errors[situationSalarieFields.ribThirdContent] ||
                    errors[situationSalarieFields.ribLastContent]
                      ? wordingSalarie?.requiredField
                      : errors[situationSalarieFields.rib]
                      ? wordingSalarie?.INVALID_RIB
                      : null}
                  </p>
                  {errors.global && (
                    <p className={classes.error}>
                      {wordingSalarie?.requiredField}
                    </p>
                  )}
                </Grid>
              )}
              {/** RIB END */}
            </>
          )}
        </Grid>
      </div>
    </CheckAuthorization>
  );
};

export default ProfessionnelClient;
